import type { ErrorConstants } from '@/types/services/utils/axios.type.ts';

const responseConstant: ErrorConstants = {
  invalid_account_error: "invalidAccountError",
  invalid_email_error: "invalidEmailError",
  invalid_body_error: "invalidBodyError",
  unexpected_error: "unexpectedError",
  invalid_jwt_error: "invalidJwtError",
  expired_jwt_error: "expiredJwtError",
  invalid_extension_file_error: "invalidExtensionFileError",
  analysis_error: "analysisError",
  invalid_duplicate_nameplate_error: "invalidDuplicateNameplateError",
  nameplate_already_exists_error: "nameplateAlreadyExistsError",
};

export default responseConstant;
